import generateQueryParams from '@/utils/generateQueryParams';
import axiosInstance from '@/plugins/api/axiosInstance';

export default function label() {
    return {
        index
    };

    function index(options = {}) {
        const defaultValues = {
            limit: 25,
            skip: 0,
            pattern: null,
            documentType: null
        };
        const params = generateQueryParams(options, defaultValues);
        return axiosInstance.get(`label-format/search${params}`);
    }
}
